import { logger } from "./Logger";

/** OBB wireframes: `?debugObb=1` veya logger F1 ile debug seviyesi. */
export function isObbDebugDrawEnabled(): boolean {
  if (typeof window === "undefined") return false;
  const v = new URLSearchParams(window.location.search).get("debugObb");
  if (v === "1" || v === "true" || v === "") return true;
  return logger.getLogLevel() === "debug";
}

/** Varsayılan: `bindDragCollisionDebugToEngine` bu bayrağa bakıp tel çizer (`dragCollisionDebugDraw`). */
export function isDragCollisionDebugEnabled(): boolean {
  if (typeof window === "undefined") return false;
  const v = new URLSearchParams(window.location.search).get("debugCollision");
  return v === "1" || v === "true" || v === "";
}

/** ModelAligner eksen seçimi: `?debugAlign=1` — konsolda görünür (logger.debug varsayılan info’da basılmaz). */
export function isModelAlignerLogEnabled(): boolean {
  if (typeof window === "undefined") return false;
  const v = new URLSearchParams(window.location.search).get("debugAlign");
  return v === "1" || v === "true" || v === "";
}
